var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame65(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1_2835)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.75781 16.4844H2.92969C3.25333 16.4844 3.51562 16.2221 3.51562 15.8984V10C3.51562 9.67636 3.25333 9.41406 2.92969 9.41406H1.75781C0.787048 9.41406 0 10.2011 0 11.1719V14.7266C0 15.6973 0.787048 16.4844 1.75781 16.4844Z",
    fill: "currentColor",
    stroke: "#B1B6C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.2422 9.41406H17.0703C16.7467 9.41406 16.4844 9.67636 16.4844 10V17.0703C16.4844 17.3936 16.2218 17.6562 15.8984 17.6562H12.8609C12.6181 16.9757 11.9739 16.4844 11.2109 16.4844H8.82812C7.85889 16.4844 7.07031 17.2729 7.07031 18.2422C7.07031 19.2114 7.85889 20 8.82812 20H11.2109C11.9739 20 12.6181 19.5087 12.8609 18.8281H15.8984C16.8677 18.8281 17.6562 18.0396 17.6562 17.0703V16.4844H18.2422C19.213 16.4844 20 15.6973 20 14.7266V11.1719C20 10.2011 19.213 9.41406 18.2422 9.41406Z",
    fill: "currentColor",
    stroke: "#B1B6C6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.19873 8.2988C1.38 8.26355 1.56647 8.24219 1.75797 8.24219H2.92984C3.14499 8.24219 3.34885 8.28644 3.53958 8.35754C3.78143 5.01846 6.59927 2.34375 10.0002 2.34375C13.401 2.34375 16.2189 5.01846 16.4607 8.35754C16.6515 8.28644 16.8553 8.24219 17.0705 8.24219H18.2423C18.4338 8.24219 18.6203 8.26355 18.8016 8.2988C18.5265 3.69263 14.6754 0 10.0002 0C5.32486 0 1.47385 3.69263 1.19873 8.2988Z",
    fill: "currentColor",
    stroke: "#B1B6C6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2835"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame65);
export default __webpack_public_path__ + "static/media/Frame (65).80dfa6c5033ebb369dcc0f9def4a49b7.svg";
export { ForwardRef as ReactComponent };